import React from 'react';

import IconSelector from '@ibibo/icon-selector';
import {defaultTheme} from '@ibibo/build-theme';

import * as B from './Benefits.style';

const iconProps = {
  fill: defaultTheme.colors.blue.dark,
  width: '100%',
  height: '100%'
}

const BenefitsBlock = () => {
  return (
    <B.BenefitsBlockWrapper>
      <B.BenefitsBlockInner>
        <B.BenefitHeader>Real Benefits for you and your customers</B.BenefitHeader>
        <B.BenefitSubHeader>Partner with us and unfold infinite possibilities of growth</B.BenefitSubHeader>
        <B.BenefitsBlock>
          <B.BenefitWrapper>
            <B.IconWrapper>
              <B.IconInnerWrap>
                <IconSelector iconKey="freecancellation" props={iconProps} />
              </B.IconInnerWrap>
            </B.IconWrapper>
            <B.TextWrapper>Best-in-class <span>free-cancellation policies</span></B.TextWrapper>
          </B.BenefitWrapper>
          <B.BenefitWrapper>
            <B.IconWrapper>
              <B.IconInnerWrap>
                <IconSelector iconKey="sharing" props={iconProps} />
              </B.IconInnerWrap>  
            </B.IconWrapper>
            <B.TextWrapper><span>Sharing of hotels’ list</span> directly with customers via WhatsApp</B.TextWrapper>
          </B.BenefitWrapper>
          <B.BenefitWrapper>
            <B.IconWrapper>
              <B.IconInnerWrap>
                <IconSelector iconKey="searchinfo" props={iconProps} />
              </B.IconInnerWrap>
            </B.IconWrapper>
            <B.TextWrapper><span>Easy access</span> to booking and payment records</B.TextWrapper>
          </B.BenefitWrapper>
        </B.BenefitsBlock>
        <B.BenefitsBlock>
          <B.BenefitWrapper>
            <B.IconWrapper>
              <B.IconInnerWrap>
                <IconSelector iconKey="postbooking" props={iconProps} />
              </B.IconInnerWrap>  
            </B.IconWrapper>
            <B.TextWrapper><span>Easy post-booking</span> modifications and cancellation process</B.TextWrapper>
          </B.BenefitWrapper>
          <B.BenefitWrapper>
            <B.IconWrapper>
              <B.IconInnerWrap>
                <IconSelector iconKey="confirmation" props={iconProps} />
              </B.IconInnerWrap>
            </B.IconWrapper>
            <B.TextWrapper>Booking confirmations for customer printed under your <span>agency’s logo</span></B.TextWrapper>
          </B.BenefitWrapper>
        </B.BenefitsBlock>
      </B.BenefitsBlockInner>
    </B.BenefitsBlockWrapper>
  );
};

export default BenefitsBlock;
